module.exports = __webpack_public_path__ + "static/media/mpc.1d7300b2.png";